import React, { useState } from 'react';
import Impressum from './Impressum';
import Datenschutz from './Datenschutz';

/* ──────────────────────────────────────────────
   SVG ICONS (inline, no external dependencies)
   ────────────────────────────────────────────── */
const CheckIcon = () => (
  <svg className="w-5 h-5 text-teal-700 flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
  </svg>
);

const ChevronDown = ({ open }) => (
  <svg className={`w-5 h-5 text-teal-700 transition-transform duration-300 ${open ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
  </svg>
);

/* ──────────────────────────────────────────────
   STEP ICONS
   ────────────────────────────────────────────── */
const UploadIcon = () => (
  <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5" />
  </svg>
);

const SparklesIcon = () => (
  <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.455 2.456L21.75 6l-1.036.259a3.375 3.375 0 00-2.455 2.456z" />
  </svg>
);

const DocumentIcon = () => (
  <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
  </svg>
);

const ShareIcon = () => (
  <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0 0a2.25 2.25 0 103.935 2.186 2.25 2.25 0 00-3.935-2.186zm0-12.814a2.25 2.25 0 103.933-2.185 2.25 2.25 0 00-3.933 2.185z" />
  </svg>
);

const ClipboardCheckIcon = () => (
  <svg className="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 3.75h6a.75.75 0 01.75.75v.75H8.25V4.5A.75.75 0 019 3.75z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 6h10.5a1.5 1.5 0 011.5 1.5v11.25a1.5 1.5 0 01-1.5 1.5H6.75a1.5 1.5 0 01-1.5-1.5V7.5A1.5 1.5 0 016.75 6z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.5l1.75 1.75L14.5 10M9 16h6" />
  </svg>
);

/* ──────────────────────────────────────────────
   PROBLEM SECTION ICONS
   ────────────────────────────────────────────── */
const NoDocumentIcon = () => (
  <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M7 3.5h6.5L18 8v11.5a1 1 0 01-1 1H7a1 1 0 01-1-1V4.5a1 1 0 011-1z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 3.5V8H18" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeDasharray="2.5 2.5" d="M9.25 12.5h5.5M9.25 15.5h3.5" />
  </svg>
);

const ScatteredSquaresIcon = () => (
  <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <rect x="3.2" y="4" width="7" height="7" rx="1.2" transform="rotate(-8 6.7 7.5)" />
    <rect x="13.2" y="6.3" width="7" height="7" rx="1.2" transform="rotate(9 16.7 9.8)" />
    <rect x="7.7" y="13.3" width="7" height="7" rx="1.2" transform="rotate(-5 11.2 16.8)" />
  </svg>
);

const QuestionCircleIcon = () => (
  <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <circle cx="12" cy="12" r="8.25" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M9.6 9.4c.3-1.1 1.3-1.9 2.5-1.9 1.4 0 2.6 1 2.6 2.3 0 1.5-1.7 1.9-2.3 2.9-.2.3-.3.6-.3 1" />
    <circle cx="12" cy="16.3" r=".6" fill="currentColor" stroke="none" />
  </svg>
);

const LockIcon = () => (
  <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <rect x="5" y="10.5" width="14" height="9" rx="1.5" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M8 10.5V7.5a4 4 0 018 0v3" />
  </svg>
);

const TrendDownIcon = () => (
  <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M4 6.5l6 6 3.5-3.5L20 15.5" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 15.5h5v-5" />
  </svg>
);

const MegaphoneIcon = () => (
  <svg className="w-7 h-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M11 5.5L5.5 9H3.5a1 1 0 00-1 1v4a1 1 0 001 1h2L11 18.5V5.5z" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M11 5.5c3 0 5.5 2.9 5.5 6.5s-2.5 6.5-5.5 6.5" />
    <path strokeLinecap="round" strokeLinejoin="round" d="M6.5 15v3.5a1 1 0 001 1H9a1 1 0 001-1V16" />
  </svg>
);

/* ──────────────────────────────────────────────
   FAQ ITEM
   ────────────────────────────────────────────── */
function FaqItem({ question, answer }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-gray-200">
      <button
        onClick={() => setOpen(!open)}
        className="flex w-full items-center justify-between py-5 text-left"
      >
        <span className="text-lg font-semibold text-gray-900 pr-4">{question}</span>
        <ChevronDown open={open} />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${open ? 'max-h-96 pb-5' : 'max-h-0'}`}>
        <p className="text-gray-600 leading-relaxed">{answer}</p>
      </div>
    </div>
  );
}

/* ──────────────────────────────────────────────
   MAIN APP
   ────────────────────────────────────────────── */
function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [page, setPage] = useState('home');

  const navigateTo = (p) => {
    setPage(p);
    window.scrollTo(0, 0);
  };

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMobileMenuOpen(false);
  };

  if (page === 'impressum') return <Impressum onBack={() => navigateTo('home')} />;
  if (page === 'datenschutz') return <Datenschutz onBack={() => navigateTo('home')} />;

  return (
    <div className="font-sans text-gray-900 antialiased">

      {/* ═══════════════ NAVIGATION ═══════════════ */}
      <nav className="fixed top-0 left-0 right-0 bg-white/90 backdrop-blur-md z-50 border-b border-gray-100">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <button onClick={() => scrollTo('hero')} className="flex items-center gap-2">
              <span className="text-2xl font-black text-teal-700 tracking-tight">Merian.ai</span>
            </button>

            {/* Desktop nav */}
            <div className="hidden md:flex items-center gap-8">
              <button onClick={() => scrollTo('problem')} className="text-sm font-medium text-gray-600 hover:text-teal-700 transition-colors">Problem</button>
              <button onClick={() => scrollTo('so-funktionierts')} className="text-sm font-medium text-gray-600 hover:text-teal-700 transition-colors">So funktioniert's</button>
              <button onClick={() => scrollTo('vorteile')} className="text-sm font-medium text-gray-600 hover:text-teal-700 transition-colors">Vorteile</button>
              <button onClick={() => scrollTo('faq')} className="text-sm font-medium text-gray-600 hover:text-teal-700 transition-colors">FAQ</button>
              <a
                href="https://app.merian.ai"
                className="bg-teal-700 text-white text-sm font-semibold px-5 py-2.5 rounded-lg hover:bg-teal-800 transition-colors"
              >
                Zur App
              </a>
            </div>

            {/* Mobile hamburger */}
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="md:hidden p-2">
              <svg className="w-6 h-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                {mobileMenuOpen
                  ? <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                  : <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
                }
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 px-4 pb-4 space-y-2">
            <button onClick={() => scrollTo('problem')} className="block w-full text-left py-2 text-gray-700 font-medium">Problem</button>
            <button onClick={() => scrollTo('so-funktionierts')} className="block w-full text-left py-2 text-gray-700 font-medium">So funktioniert's</button>
            <button onClick={() => scrollTo('vorteile')} className="block w-full text-left py-2 text-gray-700 font-medium">Vorteile</button>
            <button onClick={() => scrollTo('faq')} className="block w-full text-left py-2 text-gray-700 font-medium">FAQ</button>
            <a href="https://app.merian.ai" className="block w-full bg-teal-700 text-white text-center font-semibold py-2.5 rounded-lg">Zur App</a>
          </div>
        )}
      </nav>

      {/* ═══════════════ HERO ═══════════════ */}
      <section id="hero" className="relative overflow-hidden bg-white pt-28 pb-20 sm:pt-36 sm:pb-28">
        {/* Decorative sand circles */}
        <div className="absolute -top-32 -left-32 w-80 h-80 bg-sand-200 rounded-full opacity-60"></div>
        <div className="absolute -top-16 -right-24 w-96 h-96 bg-sand-200 rounded-full opacity-50"></div>
        <div className="absolute bottom-0 -left-16 w-64 h-64 bg-sand-100 rounded-full opacity-40"></div>

        <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center gap-2 bg-teal-700/10 text-teal-700 text-sm font-semibold px-4 py-1.5 rounded-full mb-6">
              <span className="w-2 h-2 bg-teal-700 rounded-full"></span>
              Pre-Launch &ndash; Bald verfügbar
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-teal-700 leading-tight tracking-tight mb-6">
              Dein Arbeitszeugnis<br className="hidden sm:block" /> als Freelancer.
            </h1>

            <p className="text-lg sm:text-xl text-gray-600 leading-relaxed mb-4 max-w-2xl mx-auto">
              Mit Merian.ai holst du dir nach jedem Projekt eine verifizierte, KI-gestützte Referenz von deinem Auftraggeber ein &ndash; strukturiert, professionell und dir gehörend.
            </p>

            <p className="text-base text-gray-500 mb-10 max-w-xl mx-auto">
              Du lieferst. Merian.ai sorgt dafür, dass das auch jeder sieht.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://app.merian.ai"
                className="bg-teal-700 text-white text-lg font-semibold px-8 py-4 rounded-xl hover:bg-teal-800 transition-colors shadow-lg shadow-teal-700/20"
              >
                Jetzt einloggen
              </a>
              <button
                onClick={() => scrollTo('so-funktionierts')}
                className="border-2 border-gray-200 text-gray-700 text-lg font-semibold px-8 py-4 rounded-xl hover:border-teal-700 hover:text-teal-700 transition-colors"
              >
                So funktioniert's
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════ SOCIAL PROOF STRIP ═══════════════ */}
      <section className="bg-sand-100 py-8">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap items-center justify-center gap-8 sm:gap-16 text-center">
            <div>
              <p className="text-3xl font-bold text-teal-700">Kostenlos</p>
              <p className="text-sm text-gray-500 mt-1">1 Referenzanfrage pro Jahr inklusive</p>
            </div>
            <div className="hidden sm:block w-px h-10 bg-gray-300"></div>
            <div>
              <p className="text-3xl font-bold text-teal-700">~10 Min</p>
              <p className="text-sm text-gray-500 mt-1">für den Referenzgeber</p>
            </div>
            <div className="hidden sm:block w-px h-10 bg-gray-300"></div>
            <div>
              <p className="text-3xl font-bold text-teal-700">100%</p>
              <p className="text-sm text-gray-500 mt-1">Deine Referenz, deine Daten</p>
            </div>
          </div>
        </div>
      </section>

      {/* ═══════════════ PROBLEM ═══════════════ */}
      <section id="problem" className="py-20 sm:py-28 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Das Problem, das jeder Freelancer kennt
            </h2>
            <p className="text-lg text-gray-500">
              Angestellte bekommen ein Arbeitszeugnis. Freelancer bekommen &ndash; nichts.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              {
                title: 'Kein Arbeitszeugnis',
                desc: 'Nach Projektabschluss gibt es kein standardisiertes Dokument, das deine Leistung bestätigt.',
                icon: <NoDocumentIcon />,
              },
              {
                title: 'Keine einheitliche Struktur',
                desc: 'Jeder Auftraggeber verwendet ein anderes Format. Es gibt keinen Standard für Freelancer-Referenzen.',
                icon: <ScatteredSquaresIcon />,
              },
              {
                title: 'Hemmschwelle beim Anfragen',
                desc: 'Viele Freelancer fragen nicht nach einer Referenz – aus Unsicherheit oder Angst, aufdringlich zu wirken.',
                icon: <QuestionCircleIcon />,
              },
              {
                title: 'Plattformgebundene Referenzen',
                desc: 'Bewertungen auf freelance.de, Malt oder LinkedIn sind dort gefangen – nicht übertragbar und nicht dir gehörend.',
                icon: <LockIcon />,
              },
              {
                title: 'Geringe Aussagekraft',
                desc: 'Freitextfelder enthalten oft oberflächliche Aussagen ohne Bezug zu konkreten Skills oder Projektergebnissen.',
                icon: <TrendDownIcon />,
              },
              {
                title: 'Nur Selbstdarstellung',
                desc: 'Ohne verifizierte Referenzen bist du auf deine eigene Darstellung angewiesen – Recruiter haben keinen Beweis.',
                icon: <MegaphoneIcon />,
              },
            ].map((item, i) => (
              <div key={i} className="bg-gray-50 rounded-2xl p-6 text-center hover:shadow-md transition-shadow">
                <div className="inline-flex items-center justify-center w-14 h-14 bg-teal-700/10 text-teal-700 rounded-xl mb-4">
                  {item.icon}
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-gray-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════ HOW IT WORKS ═══════════════ */}
      <section id="so-funktionierts" className="py-20 sm:py-28 bg-sand-100">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              So funktioniert Merian.ai
            </h2>
            <p className="text-lg text-gray-500">
              In 5 einfachen Schritten zur verifizierten Referenz &ndash; für dich und deinen Auftraggeber.
            </p>
          </div>

          <div className="grid md:grid-cols-5 gap-4">
            {[
              {
                step: 1,
                icon: <UploadIcon />,
                title: 'Projekt hochladen',
                desc: 'Lade dein Profil, die Projektbeschreibung und die Kontaktdaten deines Auftraggebers hoch.',
              },
              {
                step: 2,
                icon: <SparklesIcon />,
                title: 'KI erstellt Fragenkatalog',
                desc: 'Die KI generiert projektspezifische Fragen – keine generischen Vorlagen, sondern individuell auf dein Projekt zugeschnitten.',
              },
              {
                step: 3,
                icon: <ClipboardCheckIcon />,
                title: 'Fragebogen beantworten',
                desc: 'Dein Auftraggeber erhält einen Link per E-Mail und füllt den Fragebogen eigenständig aus (~10 Min.) – kein Account nötig.',
              },
              {
                step: 4,
                icon: <DocumentIcon />,
                title: 'Referenzbericht',
                desc: 'Aus den Antworten entsteht automatisch ein professioneller, strukturierter Referenzbericht mit Verifikationsstempel.',
              },
              {
                step: 5,
                icon: <ShareIcon />,
                title: 'Teilen & nutzen',
                desc: 'Exportiere als PDF, teile per Link oder binde den Bericht direkt in deine Bewerbungsunterlagen ein.',
              },
            ].map((item) => (
              <div key={item.step} className="relative bg-white rounded-2xl p-6 text-center shadow-sm hover:shadow-md transition-shadow">
                <div className="inline-flex items-center justify-center w-14 h-14 bg-teal-700/10 text-teal-700 rounded-xl mb-4">
                  {item.icon}
                </div>
                <div className="absolute top-4 right-4 text-sm font-bold text-sand-400">{item.step}/5</div>
                <h3 className="text-base font-bold text-gray-900 mb-2">{item.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════ BENEFITS / USPs ═══════════════ */}
      <section id="vorteile" className="py-20 sm:py-28 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Warum Merian.ai?
            </h2>
            <p className="text-lg text-gray-500">
              Die Referenzplattform, die Freelancern gehört &ndash; nicht einer Plattform.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {[
              {
                title: 'Plattformunabhängig',
                desc: 'Deine Referenz gehört dir. Nutze sie auf freelance.de, LinkedIn, Malt, in E-Mails oder in deinem eigenen Portfolio – überall.',
              },
              {
                title: 'Fragen, die zählen',
                desc: 'KI-generierte Spezialfragen zu deinem Projekt, kombiniert mit bewährten Standardfragen zu Skills, Zusammenarbeit und Rehire-Signalen – den Indikatoren, auf die Recruiter wirklich achten.',
              },
              {
                title: 'Verifiziert durch Drittpartei',
                desc: 'Jede Referenz trägt einen Verifikationsstempel. Keine Selbst-Bestätigung möglich – das schafft echtes Vertrauen.',
              },
              {
                title: 'Einheitliches Format',
                desc: 'Strukturierte Berichte mit Hard Skills, Soft Skills, Projektergebnissen und Empfehlungsstatus – vergleichbar wie ein Arbeitszeugnis.',
              },
              {
                title: 'Minimaler Aufwand für Auftraggeber',
                desc: 'Kein Account, kein Login. Dein Auftraggeber klickt auf einen Link und beantwortet die Fragen in rund 10 Minuten.',
              },
              {
                title: 'Zentrales Referenz-Portfolio',
                desc: 'Alle Referenzen an einem Ort. Per Link teilbar, als PDF exportierbar, mit deinem eigenen Branding versehen.',
              },
            ].map((item, i) => (
              <div key={i} className="flex gap-4">
                <div className="flex-shrink-0 mt-1">
                  <div className="w-8 h-8 bg-teal-700/10 rounded-lg flex items-center justify-center">
                    <CheckIcon />
                  </div>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-1">{item.title}</h3>
                  <p className="text-gray-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════ COMPARISON ═══════════════ */}
      <section className="py-20 sm:py-28 bg-gray-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Merian.ai vs. Status Quo
            </h2>
            <p className="text-lg text-gray-500">
              Warum bestehende Lösungen nicht ausreichen.
            </p>
          </div>

          <div className="max-w-4xl mx-auto overflow-x-auto">
            <table className="w-full text-left">
              <thead>
                <tr className="border-b-2 border-teal-700">
                  <th className="py-4 pr-4 text-sm font-bold text-gray-900"></th>
                  <th className="py-4 px-4 text-sm font-bold text-gray-400">Bisherige Lösung</th>
                  <th className="py-4 pl-4 text-sm font-bold text-teal-700">Merian.ai</th>
                </tr>
              </thead>
              <tbody className="text-sm">
                {[
                  ['Struktur', 'Freitext ohne Standard', 'Einheitlicher, strukturierter Bericht'],
                  ['Verifizierung', 'Nicht verifiziert', 'Drittpartei-Verifikation'],
                  ['Eigentum', 'Gehört der Plattform', 'Gehört dir'],
                  ['Portabilität', 'Nur auf einer Plattform', 'Überall nutzbar (PDF, Link, etc.)'],
                  ['Aufwand Referenzgeber', 'Hoch oder unklar', '~10 Min, kein Account nötig'],
                  ['Tiefe', 'Oberflächlich', 'Individuelle KI-Fragen + Standardmetriken für echte Substanz'],
                ].map(([label, old, merian], i) => (
                  <tr key={i} className="border-b border-gray-200">
                    <td className="py-3.5 pr-4 font-semibold text-gray-900">{label}</td>
                    <td className="py-3.5 px-4 text-gray-400">{old}</td>
                    <td className="py-3.5 pl-4 text-teal-700 font-medium">{merian}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* ═══════════════ TARGET AUDIENCE ═══════════════ */}
      <section className="py-20 sm:py-28 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Für wen ist Merian.ai?
            </h2>
            <p className="text-lg text-gray-500">
              Für alle Freelancer und Solo-Selbstständigen, die regelmäßig Projekte abschließen und ihren Wert nachweisen wollen.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-4xl mx-auto">
            {[
              { title: 'IT & Software', items: ['Entwickler', 'DevOps', 'Data Scientists', 'IT-Berater', 'Cloud-Spezialisten'] },
              { title: 'Business & Transformation', items: ['Business Analysten', 'PMO', 'Change Management', 'Organisationsentwicklung'] },
              { title: 'Marketing & Content', items: ['Online-Marketing', 'SEO', 'Content Marketing', 'Social Media'] },
              { title: 'Beratung & Management', items: ['Unternehmensberater', 'Projektmanager', 'Interim Manager'] },
              { title: 'Sales & BD', items: ['Vertriebsexperten', 'Business Development', 'Account Manager'] },
              { title: 'Und weitere...', items: ['Alle Freelancer mit projektbasierter Arbeit im DACH-Raum'] },
            ].map((cat, i) => (
              <div key={i} className="bg-sand-100 rounded-2xl p-6">
                <h3 className="text-lg font-bold text-teal-700 mb-3">{cat.title}</h3>
                <ul className="space-y-1.5">
                  {cat.items.map((item, j) => (
                    <li key={j} className="flex items-start gap-2 text-sm text-gray-600">
                      <CheckIcon />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══════════════ FAQ ═══════════════ */}
      <section id="faq" className="py-20 sm:py-28 bg-gray-50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
              Häufige Fragen
            </h2>
          </div>

          <div>
            <FaqItem
              question="Wem gehört die Referenz?"
              answer="Die Referenz gehört vollständig dir als Freelancer. Du kannst sie jederzeit herunterladen, teilen, in Bewerbungen einbinden oder löschen."
            />
            <FaqItem
              question="Muss sich der Referenzgeber registrieren?"
              answer="Nein. Dein Auftraggeber erhält einen Link per E-Mail und kann den Fragebogen ganz ohne Account und Login ausfüllen."
            />
            <FaqItem
              question="Kann ich die Referenz bearbeiten?"
              answer="Nein. Die Referenz wird ausschließlich auf Basis der Aussagen des Referenzgebers erstellt. Das ist die Grundlage der Glaubwürdigkeit."
            />
            <FaqItem
              question="Wie lange dauert es für den Referenzgeber?"
              answer="Circa 10 Minuten. Der Fragebogen ist bewusst kurz gehalten – kein langes Formular, keine komplizierten Formulierungen."
            />
            <FaqItem
              question="Kann der Referenzgeber anonym bleiben?"
              answer="Ja. Der Unternehmensname kann auf Wunsch des Referenzgebers anonymisiert werden. Der Verifizierungsstatus bleibt trotzdem erhalten."
            />
            <FaqItem
              question="Wie ist das mit dem Datenschutz?"
              answer="Merian.ai ist DSGVO-konform. Daten werden ausschließlich zur Erstellung der Referenz verwendet und nicht an Dritte weitergegeben."
            />
            <FaqItem
              question="In welchen Sprachen ist der Service verfügbar?"
              answer="Zum Launch: Deutsch. Englisch ist kurzfristig geplant."
            />
          </div>
        </div>
      </section>

      {/* ═══════════════ FOOTER ═══════════════ */}
      <footer className="bg-gray-900 text-gray-400 py-12">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <span className="text-xl font-black text-white tracking-tight">Merian.ai</span>
              <p className="text-sm mt-1">Die Referenzplattform für Freelancer im DACH-Raum.</p>
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-4 text-sm">
              <button onClick={() => navigateTo('impressum')} className="hover:text-white transition-colors">Impressum</button>
              <span className="hidden sm:block text-gray-600">|</span>
              <button onClick={() => navigateTo('datenschutz')} className="hover:text-white transition-colors">Datenschutz</button>
              <span className="hidden sm:block text-gray-600">|</span>
              <span>&copy; {new Date().getFullYear()} Merian.ai</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
